"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateOptimalWindowPosition = exports.getNestedElements = exports.calculateIntersection = exports.calculateWindowPosition = exports.RIGHT_BOTTOM = exports.CENTER_BOTTOM = exports.LEFT_BOTTOM = exports.RIGHT_CENTER = exports.LEFT_CENTER = exports.RIGHT_TOP = exports.CENTER_TOP = exports.LEFT_TOP = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// The positions listed below are the ones we currently provide support for
var LEFT_TOP = 'left top';
exports.LEFT_TOP = LEFT_TOP;
var CENTER_TOP = 'center top';
exports.CENTER_TOP = CENTER_TOP;
var RIGHT_TOP = 'right top';
exports.RIGHT_TOP = RIGHT_TOP;
var LEFT_CENTER = 'left center';
exports.LEFT_CENTER = LEFT_CENTER;
var RIGHT_CENTER = 'right center';
exports.RIGHT_CENTER = RIGHT_CENTER;
var LEFT_BOTTOM = 'left bottom';
exports.LEFT_BOTTOM = LEFT_BOTTOM;
var CENTER_BOTTOM = 'center bottom';
exports.CENTER_BOTTOM = CENTER_BOTTOM;
var RIGHT_BOTTOM = 'right bottom';
exports.RIGHT_BOTTOM = RIGHT_BOTTOM;

var getXPosition = function getXPosition(position, width, left, componentType) {
  if (position === LEFT_TOP || position === LEFT_BOTTOM) {
    return "".concat(left, "px");
  }

  if (position === RIGHT_TOP || position === RIGHT_BOTTOM) {
    return "calc(-100% + ".concat(left + width, "px)");
  }

  if (position === CENTER_TOP || position === CENTER_BOTTOM) {
    return "calc(-50% + ".concat(parseInt(left + width / 2, 10), "px)");
  }

  if (position === LEFT_CENTER) {
    return "calc(".concat(left, "px - 100% - var(--").concat(componentType, "-buffer-margin))");
  }

  if (position === RIGHT_CENTER) {
    return "calc(".concat(left + width, "px + var(--").concat(componentType, "-buffer-margin))");
  }
};

var getYPosition = function getYPosition(position, height, top, componentType) {
  if (position === LEFT_TOP || position === CENTER_TOP || position === RIGHT_TOP) {
    return "calc(".concat(top, "px - 100% - var(--").concat(componentType, "-buffer-margin))");
  }

  if (position === LEFT_CENTER || position === RIGHT_CENTER) {
    return "calc(-50% + ".concat(parseInt(top + height / 2, 10), "px)");
  }

  if (position === LEFT_BOTTOM || position === CENTER_BOTTOM || position === RIGHT_BOTTOM) {
    return "calc(".concat(top + height, "px + var(--").concat(componentType, "-buffer-margin))");
  }
};

var calculateWindowPosition = function calculateWindowPosition(position, target, componentType) {
  var _target$getBoundingCl = target.getBoundingClientRect(),
      left = _target$getBoundingCl.left,
      width = _target$getBoundingCl.width,
      height = _target$getBoundingCl.height,
      top = _target$getBoundingCl.top;

  var w = parseInt(width, 10);
  var h = parseInt(height, 10);
  var t = parseInt(top, 10);
  var l = parseInt(left, 10);
  return {
    transform: "translate3d(".concat(getXPosition(position, w, l, componentType), ", ").concat(getYPosition(position, h, t, componentType), ", 0)")
  };
};

exports.calculateWindowPosition = calculateWindowPosition;

var getElementFromPoint = function getElementFromPoint(x, y) {
  try {
    return document.elementFromPoint(x, y);
  } catch (err) {
    return null;
  }
};

var calculateIntersection = function calculateIntersection(position, target, portal) {
  var thresholdValues = {
    bottom: 0.1,
    center: 0.5
  };

  var _target$getBoundingCl2 = target.getBoundingClientRect(),
      x = _target$getBoundingCl2.x,
      y = _target$getBoundingCl2.y,
      height = _target$getBoundingCl2.height;

  var coordinateElement = getElementFromPoint(x, y);
  var direction = position && position.split(' ')[1];
  var threshold = thresholdValues[direction] || 1;
  y = y + height - height * threshold;
  return coordinateElement && (coordinateElement.contains(target) || target.contains(coordinateElement) || portal.contains(coordinateElement));
};

exports.calculateIntersection = calculateIntersection;

var getNestedElements = function getNestedElements(event) {
  return event.nativeEvent.path ? event.nativeEvent.path.filter(function (child, index) {
    return child.className && child.className.split(' ').includes('co-popup');
  }) : [];
};

exports.getNestedElements = getNestedElements;

var calculateAvailableSpace = function calculateAvailableSpace(portalWindow, target) {
  var _portalWindow$getBoun = portalWindow.getBoundingClientRect(),
      portalWidth = _portalWindow$getBoun.width,
      portalHeight = _portalWindow$getBoun.height;

  var _target$getBoundingCl3 = target.getBoundingClientRect(),
      targetX = _target$getBoundingCl3.x,
      targetY = _target$getBoundingCl3.y,
      targetWidth = _target$getBoundingCl3.width,
      targetHeight = _target$getBoundingCl3.height;

  var hasSpaceOnTop = targetY - portalHeight > 0;
  var hasSpaceOnRight = targetX + targetWidth + portalWidth < window.innerWidth;
  var hasSpaceOnBottom = targetY + targetHeight + portalHeight < window.innerHeight;
  var hasSpaceOnLeft = targetX + targetWidth - portalWidth > 0;
  var hasSpaceOnCenterX = targetX + targetWidth / 2 - portalWidth / 2 > 0 && targetX + targetWidth / 2 + portalWidth / 2 < window.innerWidth;
  var hasSpaceOnCenterY = targetY + targetHeight / 2 - portalHeight / 2 > 0 && targetY + targetHeight / 2 + portalHeight / 2 < window.innerHeight;
  return {
    hasSpaceOnTop: hasSpaceOnTop,
    hasSpaceOnRight: hasSpaceOnRight,
    hasSpaceOnBottom: hasSpaceOnBottom,
    hasSpaceOnLeft: hasSpaceOnLeft,
    hasSpaceOnCenterX: hasSpaceOnCenterX,
    hasSpaceOnCenterY: hasSpaceOnCenterY
  };
};

var hasSpaceOnDefaultPosition = function hasSpaceOnDefaultPosition(portalWindow, target, defaultPosition) {
  var _calculateAvailableSp = calculateAvailableSpace(portalWindow, target),
      hasSpaceOnTop = _calculateAvailableSp.hasSpaceOnTop,
      hasSpaceOnRight = _calculateAvailableSp.hasSpaceOnRight,
      hasSpaceOnBottom = _calculateAvailableSp.hasSpaceOnBottom,
      hasSpaceOnLeft = _calculateAvailableSp.hasSpaceOnLeft,
      hasSpaceOnCenterX = _calculateAvailableSp.hasSpaceOnCenterX,
      hasSpaceOnCenterY = _calculateAvailableSp.hasSpaceOnCenterY;

  var _defaultPosition$spli = defaultPosition.split(' '),
      _defaultPosition$spli2 = _slicedToArray(_defaultPosition$spli, 2),
      defaultX = _defaultPosition$spli2[0],
      defaultY = _defaultPosition$spli2[1];

  if (defaultY === 'top' && !hasSpaceOnTop) return false;
  if (defaultX === 'left' && !hasSpaceOnRight) return false;
  if (defaultY === 'bottom' && !hasSpaceOnBottom) return false;
  if (defaultX === 'right' && !hasSpaceOnLeft) return false;
  if (defaultY === 'center' && !hasSpaceOnCenterY) return false;
  if (defaultX === 'center' && !hasSpaceOnCenterX) return false;
  return true;
};

var calculateOptimalWindowPosition = function calculateOptimalWindowPosition(defaultPosition, position, portalWindow, window, target) {
  var _position$split = position.split(' '),
      _position$split2 = _slicedToArray(_position$split, 2),
      positionX = _position$split2[0],
      positionY = _position$split2[1];

  var _defaultPosition$spli3 = defaultPosition.split(' '),
      _defaultPosition$spli4 = _slicedToArray(_defaultPosition$spli3, 2),
      defaultPositionX = _defaultPosition$spli4[0],
      defaultPositionY = _defaultPosition$spli4[1];

  if (hasSpaceOnDefaultPosition(portalWindow, target, defaultPosition)) {
    return defaultPosition;
  }

  var _calculateAvailableSp2 = calculateAvailableSpace(portalWindow, target),
      hasSpaceOnTop = _calculateAvailableSp2.hasSpaceOnTop,
      hasSpaceOnRight = _calculateAvailableSp2.hasSpaceOnRight,
      hasSpaceOnBottom = _calculateAvailableSp2.hasSpaceOnBottom,
      hasSpaceOnLeft = _calculateAvailableSp2.hasSpaceOnLeft,
      hasSpaceOnCenterX = _calculateAvailableSp2.hasSpaceOnCenterX,
      hasSpaceOnCenterY = _calculateAvailableSp2.hasSpaceOnCenterY;

  var suggestedX = positionX;
  var suggestedY = positionY;

  if (defaultPositionY === 'center' && hasSpaceOnCenterY) {
    suggestedY = 'center';
  } else {
    if (!hasSpaceOnTop && hasSpaceOnBottom) {
      suggestedY = 'bottom';
    }

    if (!hasSpaceOnBottom && hasSpaceOnTop) {
      suggestedY = 'top';
    }
  }

  if (defaultPositionY === 'center' && suggestedY !== 'center') {
    suggestedX = defaultPositionX === 'right' ? 'left' : 'right';
  } else if (defaultPositionY === 'center' && suggestedY === 'center') {
    suggestedX = defaultPositionX;
  } else if (defaultPositionX === 'center' && hasSpaceOnCenterX) {
    suggestedX = 'center';
  } else {
    if (!hasSpaceOnRight && hasSpaceOnLeft) {
      suggestedX = positionY === 'center' ? 'left' : 'right';
    }

    if (!hasSpaceOnLeft && hasSpaceOnRight) {
      suggestedX = positionY === 'center' ? 'right' : 'left';
    }
  }

  return "".concat(suggestedX, " ").concat(suggestedY);
};

exports.calculateOptimalWindowPosition = calculateOptimalWindowPosition;